<template>
	<div class="card">
		<header class="card-header">
			<h3 class="card-title">General Settings</h3>
		</header>
		<div class="card-body">
			<div class="alert alert-primary alert--small" v-if="editorGeneral.isDraft">
				<div class="alert-icon fas fa-info-circle"></div>
				<div class="alert-content">
					<h4>You are editing a draft.</h4>
					<p>An editor needs to approve your changes before going live.</p>
				</div>
			</div>
			<section class="publishing-tools">
				<a class="btn btn-primary mb-1" href="#" @click.prevent="saveDraft">
					<i class="fas fa-save"></i> Save Draft
				</a>
				<a class="btn btn-success" @click.prevent="saveAndPublish">
					<i class="fas fa-check"></i> Save & Publish
				</a>
				<div class="action-links">
					<a :href="generatedUrl + editorGeneral.url + '/draft?nocache=true&hash=' + authPixelHash" target="_blank">Preview Draft</a>
					<a :href="generatedUrl + editorGeneral.url" target="_blank">Open Live</a>
					<a class="text-danger" href="#" @click.prevent="deleteDraft">Delete Draft</a>
				</div>
			</section>
			<section>
				<div class="form-group">
					<label for="author">Author</label>
					<select id="author" v-model="editorGeneral.author_id">
						<option value="">Please select an Author</option>
						<option :value="author.id" v-for="author in editorGeneral.authors">{{ author.name }}</option>
					</select>
					<p class="input-error" v-if="errors.errors.providerReviewEditorGeneral_author_id">{{ errors.errors.providerReviewEditorGeneral_author_id }}</p>
				</div>
				<div class="form-group">
					<label for="date">Display Date</label>
					<input id="date" type="date" v-model="editorGeneral.display_date[clickedLang]">
					<p class="input-error" v-if="errors.errors.providerReviewEditorGeneral_display_date">{{ errors.errors.providerReviewEditorGeneral_display_date }}</p>
				</div>
				<footer class="card-footer pt-footer">
					<strong>Last Updated:</strong> {{ editorGeneral.last_updated }}
				</footer>
			</section>
		</div>
		<loader></loader>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";

	export default {
		props: {
			editorGeneral: {
				required: true
			},
			generatedUrl: {
				type: String
			},
			authPixelHash: {
				type: String
			},
			errors: {}
		},
		data() {
			return {
				authPixelHash: this.authPixelHash,
				clickedLang: this.$defaultLanguage.locale,
			}
		},
		mounted() {
			let vm = this;
			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
		},
		methods: {
			saveDraft: function () {
				eventBus.$emit('onLoaderStart');
				eventBus.$emit('onProviderReviewSaveDraft');
			},
			saveAndPublish: function () {
				eventBus.$emit('onLoaderStart');
				eventBus.$emit('onProviderReviewSaveDraftAndPublish');
			},
			deleteDraft: function () {
				eventBus.$emit('onLoaderStart');
				eventBus.$emit('onProviderReviewDeleteDraft');
			}
		}
	}
</script>

<style scoped>

</style>
